<script>
import axios from 'axios';
import upperFirst from 'lodash/upperFirst';

const pages = {};

export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      content: '',
      isLoading: false,
    };
  },

  created() {
    const url = `/pages/${this.$i18n.locale}/${this.name}.txt`;

    if (pages[url]) {
      this.content = pages[url];
      return;
    }

    this.isLoading = true;
    axios.get(url)
      .then(({ data }) => {
        pages[url] = data;
        this.content = data;
        this.isLoading = false;
      })
      .catch((error) => {
        this.isLoading = false;
        this.$trackError(error);
      });

    this.$trackPageView(upperFirst(this.name), `/modal/${this.name}`);
  },
};
</script>

<template>
  <div class="page">
    {{ content }}
    <p v-show="isLoading" class="text-center fsize-5 color-main" v-t="'loading'" />
  </div>
</template>

<style lang="scss" scoped>
.page {
  white-space: pre-wrap;
}
</style>
